/**
 * Przy zapisie szablonów: emoji (znaki spoza BMP) zamieniane są na encje HTML &#codePoint;,
 * żeby backend mógł je poprawnie przechować.
 */
export const encodeEmojiForBackend = (text: string): string => {
  if (text == null || typeof text !== 'string') return text
  return Array.from(text)
    .map((char) => {
      const codePoint = char.codePointAt(0)
      if (!codePoint) return char
      return codePoint > 0xffff ? `&#${codePoint};` : char
    })
    .join('')
}

/**
 * Przy wyświetlaniu szablonów: encje HTML &#codePoint; lub &#xhex; zamieniane są z powrotem na emoji.
 */
export const decodeEmojiFromBackend = (text: string): string => {
  if (text == null || typeof text !== 'string') return text
  return text.replace(/&#(\d+);|&#x([0-9a-fA-F]+);/g, (_, decimal, hex) => {
    const codePoint = hex != null ? parseInt(hex, 16) : parseInt(decimal, 10)
    return Number.isNaN(codePoint) ? (hex != null ? `&#x${hex};` : `&#${decimal};`) : String.fromCodePoint(codePoint)
  })
}
